import axios from './api';

import { formatQuestion, transformQuestion } from './utilities/helpers';

/**
 * create question
 * @param {Object} options
 * @param {Object} options.question
 * @param {AbortSignal} [options.signal]
 * @return {Promise}
 */
export const createQuestion = async ({ question, signal }) => {
  return axios({
    data: formatQuestion(question),
    method: 'post',
    signal,
    url: '/instantsurvey/question',
  }).then(({ data }) => transformQuestion(data));
};

/**
 * read question
 * @param {Object} options
 * @param {String} options.id
 * @param {AbortSignal} options.signal
 * @return {Promise}
 */
export const readQuestion = async ({ id, signal }) => {
  return axios({
    method: 'get',
    signal,
    url: `/instantsurvey/question/${id}`,
  }).then(({ data }) => transformQuestion(data));
};

/**
 * update question
 * @param {Object} options
 * @param {Object} options.question
 * @param {AbortSignal} [options.signal]
 * @return {Promise}
 */
export const updateQuestion = async ({ question, signal }) => {
  return axios({
    data: formatQuestion(question),
    method: 'put',
    signal,
    url: `/instantsurvey/question/${question.id}`,
  }).then(({ data }) => transformQuestion(data));
};

/** update question top and bottom options
 * @param {Object} options
 * @param {Number[]} options.bottomNOptions
 * @param {Number} options.questionId
 * @param {AbortSignal} [options.signal]
 * @param {Number} options.surveyId
 * @param {Number[]} options.topNOptions
 * @return {Promise}
 */
export const updateQuestionTopBottomOptions = async ({
  bottomNOptions,
  questionId,
  signal,
  surveyId,
  topNOptions,
}) => {
  return axios({
    data: {
      bottom_n_options: bottomNOptions,
      top_n_options: topNOptions,
    },
    method: 'put',
    signal,
    url: `/instantsurvey/instantsurvey/${surveyId}/question/${questionId}`,
  });
};
